// Structural subset of the setting store, so this module doesn't depend on stores/ and so a
// swapped venue name and city can't type-check.
export interface TitleVenue {
  venue_name: string
  city: string
  state: string
}

interface TitleOptions {
  // Event pages (shows, performances, residencies) append the city and state, which is what local
  // searches carry; utility pages (Legal, Terms, Calendar) spend the title budget on their own name.
  locality?: boolean
}

// Builds the one `<title>` string every guest page publishes, which SSRHead also feeds to og:title
// and twitter:title.
export function buildPageTitle(
  segments: (string | null | undefined)[],
  venue: TitleVenue,
  { locality = false }: TitleOptions = {},
): string {
  // Venue.name and Show.name are both blank=True, and the address is all-or-nothing but blank until
  // staff fill it in, so every segment is trimmed and the place is assembled from whichever parts
  // exist — a blank one would otherwise publish a dangling separator ("Album Release Party - Sun,
  // Dec 24 - ", "Christmas Shows - , Austin, TX"), which is truthy and so survives SSRHead's
  // emptiness guards.
  const venueName = venue.venue_name.trim()
  const name = segments
    .map(segment => segment?.trim())
    .filter(Boolean)
    .join(' - ')
  if (!name) return venueName
  const city = venue.city.trim()
  const region = venue.state.trim()
  const place = [venueName, locality && city && region ? `${city}, ${region}` : '']
    .filter(Boolean)
    .join(', ')
  return place ? `${name} - ${place}` : name
}
